const YYYY_MM_DD = /^(\d{4})-(\d{2})-(\d{2})$/;

// "YYYY-MM-DD" 문자열을 브라우저 로컬 자정 Date 로 변환한다.
// `new Date("YYYY-MM-DD")` 는 UTC 자정으로 파싱되어 사용자 timezone 에 따라
// `.getDate()` 결과가 달라지는 함정이 있어, 본 함수는 그 함정을 회피하기 위해
// 명시적으로 `new Date(year, month-1, day)` 를 사용한다.
export function parseLocalDate(yyyyMmDd: string): Date {
  const match = YYYY_MM_DD.exec(yyyyMmDd);
  if (!match) {
    return new Date(yyyyMmDd);
  }
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  return new Date(year, month - 1, day);
}
